import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { setPagePromotion } from 'redux/modules/page';
import { Metadata } from 'components/Metadata/Metadata';

export class CmsMetadataUnwrapped extends PureComponent {
  constructor(props) {
    super(props);
    const { promoAlias } = props;
    if (promoAlias) {
      props.setPagePromotion(promoAlias);
    }
  }

  componentDidUpdate(prevProps) {
    const { promoAlias } = this.props;
    if (promoAlias !== prevProps.promoAlias) {
      this.props.setPagePromotion(promoAlias);
    }
  }

  render() {
    return <Metadata {...this.props} />;
  }
}

CmsMetadataUnwrapped.propTypes = {
  promoAlias: PropTypes.string,
  setPagePromotion: PropTypes.func.isRequired,
};

export const CmsMetadata = decorateWith(
  connect(
    null,
    { setPagePromotion }
  ),
  withName('CmsMetadata')
)(CmsMetadataUnwrapped);
